import { createFileRoute } from '@tanstack/react-router'
import { GeneralSettingsForm } from '../../../../modules/settings/general-settings-form'
import { SettingsShell } from '../../../../modules/settings/settings-shell'

export const Route = createFileRoute('/_authed/settings/general/')({
  component: () => (
    <SettingsShell>
      <GeneralSettingsForm />
    </SettingsShell>
  ),
})
